<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <div class="content configBox " v-if="topicType">
      <myHeader></myHeader>
      <div class="config-title">模拟卷</div>
      <div class="config-cont">
        <form @submit.prevent>
          <div class="config-item">
            <p class="config-left">考试总分：</p>
            <div class="config-right">
              <input type="number" v-model="addObj.score" disabled class="noClick">
              <p>分</p>
            </div>
          </div>
          <div class="config-item">
            <p class="config-left">考试总时长：</p>
            <div class="config-right">
              <input type="number" v-model="addObj.contime" disabled class="noClick">
              <p>分钟</p>
            </div>
          </div>
          <div class="config-list">
            <div class="config-list-item" v-for="(item,index) in addObj.type_sets" :key="(index+1)">
              <div class="config-item">
                <p class="config-left">题型{{(index+1)}}：</p>
                <div class="config-right">
                  <select v-model="item.tsid" @change="selectSub($event)">
                    <option value="">请选择</option>
                    <option :value="ele.id" v-for="(ele,num) in topicTypeList" :key="(num+1)" :disabled="ele.type">{{ele.title}}</option>
                  </select>
                </div>
              </div>
              <div class="config-item">
                <p class="config-left">题目数量：</p>
                <div class="config-right">
                  <input type="number" v-model="item.num">
                </div>
              </div>
              <div class="config-item">
                <p class="config-left">考试时长：</p>
                <div class="config-right">
                  <input type="number" v-model="item.contime">
                  <p>分钟</p>
                </div>
              </div>
              <div class="config-item">
                <p class="config-left">分值：</p>
                <div class="config-right">
                  <input type="number" v-model="item.score" disabled  class="noClick">
                  <p>分</p>
                </div>
              </div>
              
              <div class="config-btn">
                <button class="btn btn-add" @click="configShow(item,index)">配置</button>
                <button class="btn btn-add" @click="topicAdd">增加</button>
                <button class="btn btn-remove" @click="topicRemove(index)">删除</button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="config-btnBox">
        <button class="btn btn-sub" @click="paperSub">提交模拟卷</button>
        <button class="btn btn-close" @click="paperHide">取消</button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="content " v-else>
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>模拟卷名称：</p>
          <input type="text" placeholder="请输入模拟卷名称" v-model="obj.title">
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>模拟卷列表</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addShow">添加模拟卷</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p style="color:#FF7543;">
                <span @click="topicAdmin(item)">
                  题目管理
                </span>
                <span @click="paperAdmin(item)">
                  试卷配置 
                </span>
                <span @click="editShow(item)">
                  编辑
                </span>
                <span @click="removeSub(item)">
                  删除 
                </span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">{{showType=='add'?'添加试卷':'编辑试卷'}}</p>
        <form>
          <div class="write-txt">
            <p>模拟卷名称：</p>
            <input type="text" v-model="buildObj.name">
          </div>
          <div class="write-txt">
            <p>是否试用：</p>
            <el-radio-group v-model="buildObj.is_free">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>

    <div class="msgBox tipsBox configTip" v-if="configType">
      <div class="contv">
        <p class="title">配置</p>
        <form>
          <div class="write-txt">
            <p style="width: 120px;">正确题目个数</p>
            <p style="width: 225px;">得分</p>
          </div>
          <div class="write-txt" v-for="(item,index) in score_list" :key="(index+1)">
            <p>{{item.num}}</p>
            <input type="text" v-model="item.score">
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="configSub">确认</button>
          <button class="btn btn-close" @click="configHide">取消</button>
        </div>
      </div>
    </div>
  </div>


  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getTestList,saveTest,delTest,getMackTestTopicType,setTest,getSetTestInfo } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'模拟卷名称'},
        {id:4,title:'创建时间'},
        {id:5,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        page:1,
        rows:10,
        mtid:'',
        qpid:''
      },
      addObj:{
        tid:'',
        score:'',
        contime:'',
        type_sets:[
          {tsid:'',num:0,contime:0,score:0}
        ]
      },
      buildObj:{
        mtid:'',
        qpid:'',
        name:'',
        is_free:''
      },
      totalPage:0,
      userData:{
        authority:[],
      },
      topicType:false,
      topicTypeList:[],
      configType:false,
      score_list:[],
      configIndex:0,
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.obj.mtid = this.buildObj.mtid = this.$route.query.mtid;
    this.obj.qpid = this.buildObj.qpid = this.$route.query.qpid;
    this.getList();

    
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    topicAdd(){
      var that = this;
      this.addObj.type_sets.push({tsid:'',num:0,contime:0,score:0,score_list:[]});
      // this.topicTypeList.forEach(function(item,index){
      //   that.addObj.type_sets.forEach(function(ele,num){
      //     if(item.id == ele.tsid){
      //       item.type = true
      //     }
      //   })
      // })
    },

    // 取消
    closeSub(){
      this.addObj.name = '';
      this.showType = '';
    },

    // 确认添加or编辑
    addSub(){
      var that = this;
      saveTest(that.buildObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      this.obj.page = 1;
      if(this.obj.title){
        delete this.obj.title;
      };
      this.buildObj.name = '';
      if(this.buildObj.tid){
        delete this.buildObj.tid;
      }
      this.dataList = [];
      this.getList();
    },

    getList(){
      var that = this;
      getTestList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.showType = 'add';
      this.addObj.name = '';
    },

    editShow(e){
      this.showType = 'edit';
      this.buildObj.tid = e.tid;
      this.buildObj.name = e.name;
      this.buildObj.is_free = JSON.stringify(e.is_free);
    },

    removeSub(e){
      var that = this;
      delTest({tid:e.tid},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    paperAdmin(e){
      var that = this;
      getMackTestTopicType({mtid:that.obj.mtid},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.topicTypeList = data.data;
        } else {
          that.$message(data.msg);
        }
      });

      getSetTestInfo({tid:e.tid},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          
          that.addObj = data.data;
          if(data.data.type_sets.length == 0){
            that.addObj.type_sets = [{tsid:'',num:0,contime:0,score:0,score_list:[]}]
          } else {
            
          };
          that.addObj.tid = e.tid;
          that.topicType = true;

        } else {
          that.$message(data.msg);
        }
      });
      
    },

    topicRemove(i){
      this.addObj.type_sets.splice(i,1);
      let sum = 0;
      for(let i = 0; i < this.addObj.type_sets.length; i++) {
        sum += parseInt(this.addObj.type_sets[i].score);
      }
      this.addObj.score = sum;
      let num = 0;
      for(let i = 0; i < this.addObj.type_sets.length; i++) {
        num += parseInt(this.addObj.type_sets[i].contime);
      }
      this.addObj.contime = num;
    },

    paperSub(){
      var that = this;
      var list = this.addObj.type_sets;
      const hasDuplicateSampleTypeId = list.some((item, index, array) => {
        return array.filter(innerItem => innerItem.tsid === item.tsid).length > 1;
      });
      if(hasDuplicateSampleTypeId){
        that.$message('题型有重复，请修改!');
        return false
      };
      setTest(that.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.topicType = false;
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    paperHide(){
      var that = this;
      this.addObj = {
        tid:'',
        score:'',
        contime:'',
        type_sets:[
          {tsid:'',num:0,contime:0,score:0}
        ]
      };
      that.topicType = false;
    },

    topicAdmin(e){
      var that = this;
      that.$router.push('/topicAdmin?tid='+e.tid);
    },

    configShow(e,j){
      var that = this;
      var list = [];
      if(e.score_list.length > 0){
        list = e.score_list
      } else {
        list.push({num:0,score:''});
      };
      var num = this.addObj.type_sets[j].num;
      var contime = this.addObj.type_sets[j].contime;
      var tid = this.addObj.type_sets[j].tid;
      if(num == '' || num == 0){
        this.$message('请填写题目数量!');
        return false;
      }
      if(contime == '' || contime == 0){
        this.$message('请填写考试时长!');
        return false;
      }
      if(tid == '' || tid == 0){
        this.$message('请填写题型!');
        return false;
      }
      // e.score_list = [];
      num = parseInt(num) + 1;
      if(num == list.length){
        this.score_list = list;
      } else {
        if(num < list.length){
          for(var i = 0;i < num;i++){
            this.score_list.push({num:list[i].num,score:list[i].score});
          };
        } else {
          // this.score_list = list;
          var cha = parseInt(num - list.length );
          var suo = list[parseInt(list.length-1)].num;
          suo = suo+1;
          console.log(cha,list[parseInt(list.length-1)].num)
          for(var i = 0;i < cha;i++){
            console.log(cha,i,'==i==')
            list.push({num:(suo+i),score:''});
          };
          e.score_list = list;
          this.score_list = list;
        }
        
        // for(var i = 0;i < num;i++){
        //   this.score_list.push({num:i,score:0});
        // };
      }
      console.log(this.score_list,'==list==')
      // if(e.score_list.length == 0){
      
      // }
      this.configType = true;
      // this.score_list = e.score_list;
      this.configIndex = j;
    },

    configSub(){
      this.addObj.type_sets[this.configIndex].score = this.addObj.type_sets[this.configIndex].score_list[this.addObj.type_sets[this.configIndex].score_list.length - 1].score;
      let sum = 0;
      for(let i = 0; i < this.addObj.type_sets.length; i++) {
        sum += parseInt(this.addObj.type_sets[i].score);
      }
      this.addObj.score = sum;
      let num = 0;
      for(let i = 0; i < this.addObj.type_sets.length; i++) {
        num += parseInt(this.addObj.type_sets[i].contime);
      }
      this.addObj.contime = num;
      this.configType = false;
    },

    configHide(){
      console.log(this.addObj,'==addObj==')
      this.configType = false;
      this.score_list = [];
    },

    selectSub(e){
      var that = this;
      var val = e.target.value;
      // this.topicTypeList.forEach(function(item,index){
      //   if(val == item.id){
      //     item.type = true
      //   }
      // });
      // this.topicTypeList.forEach(function(item,index){
      //   that.addObj.type_sets.forEach(function(ele,num){
      //     if(item.id == ele.tsid){
      //       item.type = true
      //     } else {
      //       item.type = false
      //     }
      //   })
      // })
      console.log(val,this.topicTypeList,'==list===')
    }
  },

  
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 25%;
}

.config-title{
  font-size: 18px;
  color: #3D3D3D;
  height: 36px;
  line-height: 36px;
  display: block;
}

.config-cont{
  display: block;
  height: 70%;
}

.config-cont form{
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.config-item{
  font-size: 0;
  margin-bottom: 20px;
}

.config-btn .btn,
.config-right select,
.config-right p,
.config-right input,
.config-right,
.config-left{
  font-size: 14px;
  line-height: 36px;
  height: 36px;
  display: inline-block;
  vertical-align: top;
}

.config-right input{
  background-color: #F9F9F9;
  padding: 10px;
  box-sizing: border-box;
}

.config-list .config-right select{
  width: 180px;
}

.config-list .config-item{
  display: inline-block;
  margin-right: 20px;
}

.config-btn{
  font-size: 0;
  display: inline-block;
  vertical-align: top;
}

.config-btn .btn{
  color: #477BFE;
  margin-right: 10px;
}

.config-btnBox{
  display: block;
  font-size: 0;
  margin: 50px auto 0;
}

.config-btnBox .btn{
  width: 135px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 30px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  background-color: #cbcbcb;
}

.config-btnBox .btn.btn-sub{
  background-color: #4c7efb;
  margin-right: 80px;
}

.configTip .contv{
  height: 80%;
}

.configTip .contv form{
  height: 80%;
  overflow-y: auto;
  overflow-x: hidden;
}

.noClick{
  background-color: #ccc!important;
}

.el-radio-group{
  width: 225px;
  height: 36px;
  line-height: 36px;
}

.el-radio{
  height: 36px;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/exam/imitate.vue